import { NgModule } from '@angular/core';
import { ToCurrentTimePipe } from './to-current-time.pipe';

@NgModule({
  declarations: [ToCurrentTimePipe],
  exports: [ToCurrentTimePipe],
})
export class ToCurrentTimeModule {}
